import(/* webpackMode: "eager", webpackExports: ["EntryHeader"] */ "/vercel/path0/app/manifiesto/components/entry-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingProgress"] */ "/vercel/path0/app/manifiesto/components/reading-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KirbeContent"] */ "/vercel/path0/app/manifiesto/kirbe/components/kirbe-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileTableOfContents"] */ "/vercel/path0/app/manifiesto/kirbe/components/mobile-toc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/vercel/path0/app/manifiesto/kirbe/components/table-of-contents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteFooter"] */ "/vercel/path0/components/layout/site-footer.tsx");
